module.exports = __webpack_public_path__ + "static/media/relife.364a2753.jpg";